import {
    GET_ZONES,
    GET_ZONES_SUCCESS,
    GET_ZONES_FAIL,
    ADD_ZONE,
    ADD_ZONE_SUCCESS,
    ADD_ZONE_FAIL,
    UPDATE_ZONE,
    UPDATE_ZONE_SUCCESS,
    UPDATE_ZONE_FAIL,
    DELETE_ZONE,
    DELETE_ZONE_SUCCESS,
    DELETE_ZONE_FAIL,
    SET_ZONE_FIELD_ERRORS,
  } from './actionTypes';
  
  const initialState = {
    zones: [],
    loading: false,
    error: null,
    fieldErrors: {}, // for form validation errors
  };
  
  const zoneReducer = (state = initialState, action) => {
    switch (action.type) {
      // Get Zones
      case GET_ZONES:
        return { ...state, loading: true, error: null };
  
      case GET_ZONES_SUCCESS:
        return { ...state, loading: false, zones: action.payload };
  
      case GET_ZONES_FAIL:
        return { ...state, loading: false, error: action.payload };
  
      // Add Zone
      case ADD_ZONE:
        return { ...state, loading: true, error: null };
  
      case ADD_ZONE_SUCCESS:
        return { ...state, loading: false};
  
      case ADD_ZONE_FAIL:
        return { ...state, loading: false, error: action.payload };
  
      // Update Zone
      case UPDATE_ZONE:
        return { ...state, loading: true, error: null };
  
      case UPDATE_ZONE_SUCCESS:
        return {
          ...state,
          loading: false
        };
  
      case UPDATE_ZONE_FAIL:
        return { ...state, loading: false, error: action.payload };
  
      // Delete Zone
      case DELETE_ZONE:
        return { ...state, loading: true, error: null };
  
      case DELETE_ZONE_SUCCESS:
        return {
          ...state,
          loading: false
        };
  
      case DELETE_ZONE_FAIL:
        return { ...state, loading: false, error: action.payload };
  
      // Set Field Errors
      case SET_ZONE_FIELD_ERRORS:
        return { ...state, fieldErrors: action.payload };
  
      default:
        return state;
    }
  };
  
  export default zoneReducer;
  